"use client";

import TestimonialCard from "./TestimonialCard";
import "./Testimonials.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import kid1 from "../assets/kid7.png";
import kid2 from "../assets/kid8.png";
import kid3 from "../assets/kid9.png";
import kid4 from "../assets/kid10.png";
import kid5 from "../assets/kid11.png";
import kid6 from "../assets/kid12.png";

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Muhammad Hassan",
      age: 14,
      image: kid1,
      testimonial:
        "The UI/UX design course was amazing! I can now create my own website designs. Thank you, Polymath-Kids, for this opportunity!",
      rating: 5,
      country: "Canada",
      flag: "🇨🇦",
    },
    {
      id: 2,
      name: "Areeba Fatima",
      age: 10,
      image: kid2,
      testimonial:
        "The UI/UX design course was amazing! I can now create my own website designs. Thank you, Polymath-Kids, for this opportunity!",
      rating: 5,
      country: "Pakistan",
      flag: "🇵🇰",
    },
    {
      id: 3,
      name: "Zayan Ahmed",
      age: 9,
      image: kid3,
      testimonial:
        "I loved the coding classes! Now I can make my own games and show them to my friends. The teachers are so helpful and fun!",
      rating: 5,
      country: "UAE",
      flag: "🇦🇪",
    },
    {
      id: 4,
      name: "Sophia Williams",
      age: 12,
      image: kid4,
      testimonial:
        "The math program helped me understand numbers in a whole new way. I used to struggle with math, but now it's my favorite subject!",
      rating: 5,
      country: "UK",
      flag: "🇬🇧",
    },
    {
      id: 5,
      name: "Ayesha Amad",
      age: 15,
      image: kid5,
      testimonial:
        "The graphic design course taught me skills I never thought I could learn! I'm now designing logos for my school events.",
      rating: 5,
      country: "Pakistan",
      flag: "🇵🇰",
    },
    {
      id: 6,
      name: "Carl Adrianne Silvio",
      age: 8,
      image: kid6,
      testimonial:
        "I love the robotics classes! Building and programming my own robot was the coolest thing ever. Can't wait for the next level!",
      rating: 5,
      country: "USA",
      flag: "🇺🇸",
    },
  ];

  // Custom arrow components
  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="custom-arrow prev-arrow" onClick={onClick}>
        <span>‹</span>
      </div>
    );
  };

  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="custom-arrow next-arrow" onClick={onClick}>
        <span>›</span>
      </div>
    );
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "25%",
    className: "testimonials__slider",
    customPaging: (i) => <div className="custom-dot"></div>,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: "15%",
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: "10%",
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: "0",
          centerMode: false,
        },
      },
    ],
  };

  return (
    <div className="testimonials">
      <h2 className="testimonials-title">
        <span className="what-part">What</span>{" "}
        <span className="learners-part">Our Learners Say</span>
      </h2>
      <div className="testimonials__slider">
        <Slider {...settings}>
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonials__slide">
              <TestimonialCard
                name={testimonial.name}
                age={testimonial.age}
                image={testimonial.image}
                testimonial={testimonial.testimonial}
                rating={testimonial.rating}
                country={testimonial.country}
                flag={testimonial.flag}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Testimonials;
